import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome-transforms',
	templateUrl:'./FontAwesomeTransformsPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesomeTransformsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeTransformsPluginCompPage
{
	mdContent_958 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5.options.FontAwesomeTransforms;
\`\`\``;
	mdContent_959 = `\`\`\`java
new FontAwesome<>(FontAwesomeStyles.Classic, FontAwesomeIcons.magic)
    .transform(FontAwesomeTransforms.Grow_3, FontAwesomeTransforms.Rotate_45, FontAwesomeTransforms.Right_2);
\`\`\``;
}
